export default __webpack_public_path__ + "2df35ad4d837faeb4f5f80b390d62d88.svg";